import { render, staticRenderFns } from "./ModalQRCode.vue?vue&type=template&id=35c63ed0&scoped=true"
import script from "./ModalQRCode.vue?vue&type=script&lang=js"
export * from "./ModalQRCode.vue?vue&type=script&lang=js"
import style0 from "./ModalQRCode.vue?vue&type=style&index=0&id=35c63ed0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c63ed0",
  null
  
)

export default component.exports